module.exports = __webpack_public_path__ + "static/media/galeria-fotos-5-big.4b72fc00.png";